import { Button } from "components/LEGACY/styled-components/Buttons"

interface HeaderButtonProps {
  helpLink?: string
}

const HeaderButtons = ({ helpLink }: HeaderButtonProps) => {
  return (
    <>
      <style jsx>{`
        .helpButton {
          margin-left: auto;
          text-decoration: none;
        }
      `}</style>

      {helpLink && (
        <a href={helpLink} target="_blank" rel="noreferrer" className="helpButton">
          <Button ghost>Hilfe</Button>
        </a>
      )}
    </>
  )
}

export default HeaderButtons
